<div class="card-title mb-5">
  <div class="flex justify-between items-center mb-5">
    <span class="text-2xl font-bold text-inverse-primary">{{
      "CASE_DETAIL.SYSTEM_RESULTS" | translate
    }}</span>
    <div class="flex items-center gap-2">
      @for(flag of claimFlagIcons(); track $index) {
        <img
          [src]="flag.src"
          [pTooltip]="flag.tooltip"
          tooltipPosition="bottom"
          style="width: 40px; height: 40px; object-fit: contain;"
          alt=""
        />
      }
    </div>
  </div>
  <hr class="text-white" />
</div>

<div class="grid grid-cols-1 md:grid-cols-2 gap-3 mb-4">
  @for(metric of data(); track $index;){
  <div>
      <div class="flex items-center h-full bg-primary rounded-xl p-3">
      <div
        class="mr-3 flex items-center justify-center rounded-lg shrink-0 ring-1 ring-inset ring-white/30"
        [ngClass]="metric.type === 'LEVEL_BADGE' ? getLevelBadgeColor(metric) : (metric.type === 'BOOLEAN_BADGE' ? getBooleanBadgeColor(metric) : (metric.type === 'INFO_BADGE' ? getInfoBadgeColor(metric) : getBackgroundColor(metric)))"
        style="width: 50px; height: 50px"
      >
        <i
          [ngClass]="metric.type === 'LEVEL_BADGE' ? getLevelBadgeIcon(metric) : (metric.type === 'BOOLEAN_BADGE' ? getBooleanBadgeIcon(metric) : (metric.type === 'INFO_BADGE' ? getInfoBadgeIcon(metric) : getIcon(metric)))"
        ></i>
      </div>

      <div class="grow min-w-0">
        <span class="text-white block">{{ metric.label }}
          <i
            *ngIf="metric.modelMetrics"
            class="fa fa-info-circle text-white ml-2 cursor-pointer"
            (click)="popover.toggle($event)"
          ></i>
          <p-popover
            #popover
            [dismissable]="true"
            styleClass="whitespace-pre-line"
          >
            {{ getModelTooltip(metric) }}
          </p-popover>
        </span>
        @if(metric.subtitle){
          <span class="text-white text-sm opacity-80 block">{{ metric.subtitle }}</span>
        }
        @if(metric.viewDetailsLabel){
          <button
            type="button"
            class="text-white text-sm opacity-80 underline hover:opacity-100 transition-opacity block text-left cursor-pointer"
            (click)="openDetails(metric, $event)"
          >
            {{ metric.viewDetailsLabel }}
          </button>
        }
        @if(metric.subcategory?.value){
          <div class="mt-2">
            <div class="flex flex-col items-center border border-white/80 bg-white/20 rounded-lg px-2 py-2 shadow-sm w-full overflow-hidden">
              @if(metric.subcategory?.label){
                <span class="text-white text-xs uppercase tracking-wider opacity-100 leading-tight text-center">{{ metric.subcategory?.label }}</span>
              }
              @if(metric.subcategory?.badge){
                <div class="mt-1 flex items-center justify-center gap-2 flex-wrap w-full min-w-0">
                  <span
                    class="font-bold text-inverse-primary text-xl tracking-wide leading-tight break-words min-w-0"
                    [ngClass]="getTextSize()"
                    >{{ metric.subcategory?.value }}
                  </span>
                  <span
                    class="inline-flex items-center justify-center rounded-full border border-white/80 shrink-0"
                    [ngClass]="getSubcategoryBadgeColor(metric)"
                    [attr.title]="metric.subcategory?.badge?.tooltip || null"
                    style="width: 28px; height: 28px"
                  >
                    <i class="leading-none" [ngClass]="getSubcategoryBadgeIcon(metric)"></i>
                  </span>
                </div>
              } @else {
                <span
                  class="font-bold text-inverse-primary text-xl tracking-wide leading-tight text-center mt-1 block w-full"
                  [ngClass]="getTextSize()"
                  >{{ metric.subcategory?.value }}
                </span>
              }
            </div>
          </div>
        }
          <!-- <i
            *ngIf="metric.modelMetrics"
            class="fa fa-info-circle text-white ml-2 cursor-pointer"
            (click)="op.toggle($event)"
          ></i>

          <p-overlayPanel #op [dismissable]="true" [showCloseIcon]="true">
            <div class="whitespace-pre-line">
              {{ getModelTooltip(metric) }}
            </div>
          </p-overlayPanel> -->
        @if(metric.type !== 'LEVEL_BADGE' && metric.type !== 'BOOLEAN_BADGE' && metric.type !== 'INFO_BADGE'){
          <div class="text-light mb-2 block">
            <span
              class="font-bold text-inverse-primary text-wrap"
              [ngClass]="getTextSize()"
              >{{ getDataFormat(metric) }}
            </span>
          </div>

          <div class="w-full bg-white rounded-xl" style="height: 6px">
            <div
              class="h-full rounded-xl"
              [ngClass]="getProgressBarWidthAndColor(metric).colorClass"
              [style.width]="getProgressBarWidthAndColor(metric).width"
            ></div>
          </div>
        }
      </div>
    </div>
  </div>
  }
</div>
